export const maxAllowedFileSize = 10 * 1024 * 1024
export const fileFilter = ".pdf,.jpg,.jpeg,.png,application/pdf"
export const allowedFileExt = ["pdf", "jpg", "jpeg", "png"]

export const importFileFilter = ".csv,.xlsx"